import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './CreateIrregularity.scss';

const CreateIrregularity = (props) => {
  const { t } = useTranslation();
  return (
    <div className="create-irregularity mt-5 ">
      <div className="header-section position-relative">
        <h4 className="mb-4">{t('irregularities.newIrregularity')}</h4>
        <p className="">{t('irregularities.newDescription')}</p>
      </div>
      <div className="buttons-container w-100">
        <button className="btn btn-action w-100" onClick={() => props.onCreate()}>
          {t('common.labels.create')}
        </button>
      </div>
    </div>
  );
};

export default CreateIrregularity;

CreateIrregularity.propTypes = {
  onCreate: PropTypes.func.isRequired,
};
